
import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import './AuditDescription.css';
import axios from 'axios';
import Support from '../contact-popup-module/Support';
import {
    Dialog,
    DialogContent,
} from "@mui/material";
import ShareAuditOptions from '../audit-creation-module/inspection-mode/ShareAuditOptions';

const AuditDescription = () => {
    // const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const share = `${process.env.PUBLIC_URL}/custom-icons/share.svg`;
    const calendar = `${process.env.PUBLIC_URL}/custom-icons/calendar.png`;
    const backIcon = `${process.env.PUBLIC_URL}/custom-icons/back-button.png`;
    const infoIcon = `${process.env.PUBLIC_URL}/custom-icons/info-icon.png`;
    const audit = location.state.audit;
    const userID = location.state.userID;
    const agentDetails = location.state.agentDetails;
    const [formDetails, setFormDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [open, setOpen] = useState(false);
    const [openSharePopup, setOpenSharePopup] = useState(false);
    const [selectedAuditUrl, setSelectedAuditUrl] = useState('');


    const audit_id = audit.id;
    useEffect(() => {
        console.log(audit);
        console.log(userID);
        console.log(agentDetails);

    }, [])

    const link_to_audit = (audit,) => {
        console.log(audit?.mode, 187);
        const hostname = window.location.hostname;
        const port = window.location.port;
        const baseURL = `https://${hostname}:${port}`;
        let url;
        const auditId = audit.id;
        if (audit?.mode === "video") {
            url = `/audit/video/permission/${auditId}`;
        } else if (audit?.mode === "photo") {
            url = `/audit/photo/permission/${auditId}`;
        } else {
            url = `/audit/hybrid/permission/${auditId}`;
        }
        return url;
    };

    const handleInspectionStart = (audit) => {
        const url = link_to_audit(audit);
        console.log(url);
        navigate(url)
        // window.location.href = url; // Redirect to the generated URL
    };

    useEffect(() => {
        const fetchAuditDetails = async () => {
            try {
                // Construct the URL with the SAS token
                const uploadUrl = `https://caiproduction002.blob.core.windows.net/ira/insurance-inspection-details/${audit_id}.json`;
                const sasToken = '?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D';

                // Fetch audit details using axios
                const auditDetailsFormData = await axios.get(`${uploadUrl}${sasToken}`, { responseType: "json" });
                console.log(auditDetailsFormData.data);

                // Set the audit details state
                setFormDetails(auditDetailsFormData.data);
            } catch (err) {
                // Handle errors
                console.error("Error fetching audit details:", err);
                setError("Failed to fetch audit details.");
            } finally {
                setLoading(false);
            }
        };

        // Fetch audit details when the component mounts or audit_id changes
        if (audit_id) {
            fetchAuditDetails();
        }
    }, [audit_id]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleLogout = () => {
        navigate('/login')
    }
    const handleShareClick = (audit) => {
        console.log("share clicked");
        
        const auditUrl = link_to_audit(audit); // Generate the audit URL
        setSelectedAuditUrl(auditUrl); // Set the URL for sharing
        setOpenSharePopup(true); // Open the share popup
    };

    const handleShareClose = () => {
        setOpenSharePopup(false); // Close the share popup
    };
    return (
        <div className="audit-description-container">
            {/* Header Section */}
            <div className="case-header">
                <button className="back-button" onClick={() => navigate(-1)}>
                    {/* {'<'} */}
                    <img src={backIcon} alt="Back" className="button-icon" />
                </button>
                <h1 className="header-title">Case</h1>
                <button className="info-button" onClick={handleClickOpen}>
                    {/* ? */}
                    <img src={infoIcon} alt="Info" className="button-icon" />
                </button>
            </div>
            {/* Support Popup */}
            <Dialog open={open} onClose={handleClose} className="support-popup-dialog">
                <DialogContent className="support-popup-content">
                    <Support />
                    <button onClick={handleClose} className="close-btn">close</button>
                </DialogContent>
            </Dialog>

            {/* Audit Card Section */}
            <div className="audit-cards">
                <div className="audit-card" key={audit.id}>
                    <div className="audit-header">
                        <div className="header-one">
                            <p className="audit-id">{audit.id}</p>
                            <div className="date-container">
                                <img src={calendar} alt="Calendar Icon" className="calendar-icon" />
                                <p>{audit.date}</p>
                            </div>
                        </div>

                        <div className="header-two">
                            <div className="audit-tags">
                                {audit.type.map((tag, index) => (
                                    <span key={index} className="audit-tag">{tag}</span>
                                ))}
                                {audit.mode &&
                                    // audit.mode.map((mode, index) => (
                                    <span className="audit-tag">{audit.mode}</span>
                                    // ))
                                }
                            </div>
                            <p>{audit.time}</p>
                        </div>
                    </div>

                    <div className="audit-details">
                        <p>{agentDetails && agentDetails.FirstName}</p>
                        <p>{agentDetails && agentDetails.address}</p>
                    </div>

                    <div className="audit-actions">
                        <button className="share-button" onClick={() => handleShareClick(audit)}>
                            <img src={share} alt="Share Icon" className="share-icon" />
                            Share
                        </button>
                    </div>
                </div>

                {/* Share Audit Popup */}
                <Dialog open={openSharePopup} onClose={handleShareClose} className="share-popup-dialog">
                    <DialogContent className="share-popup-content">
                        <ShareAuditOptions auditUrl={selectedAuditUrl} />
                        <button onClick={handleShareClose} className="close-btn">Close</button>
                    </DialogContent>
                </Dialog>
                <div className="case-details">
                    <h2>Case details</h2>
                    <div className="detail-item">
                        <span className="label">Name</span>
                        <span className="content">{agentDetails && `${agentDetails.FirstName} ${agentDetails.LastName}`}</span>
                    </div>
                    <div className="detail-item">
                        <span className="label">Email   </span>
                        <span className="content">{agentDetails && agentDetails.email}</span>
                    </div>
                    <div className="detail-item">
                        <span className="label">Phone</span>
                        <span className="content">{agentDetails && agentDetails.MobileNumber}</span>
                    </div>
                    <div className="detail-item">
                        <span className="label">Make</span>
                        <span className="content">{formDetails && formDetails["Make"]}</span>
                    </div>
                    <div className="detail-item">
                        <span className="label">Model</span>
                        <span className="content">{formDetails && formDetails["Model"]}</span>
                    </div>
                    <div className="detail-item">
                        <span className="label">License no</span>
                        <span className="content">{formDetails && formDetails["Dealer Code"]}</span>
                    </div>
                    <div className="detail-item">
                        <span className="label">Registration no</span>
                        <span className="content">{formDetails && formDetails["User Id"]}</span>
                    </div>
                </div>
                <button className="start-inspection-button"
                    onClick={() => handleInspectionStart(audit)}

                >Start inspection</button>
            </div>
        </div>
    );
};

export default AuditDescription;
